module.exports = __webpack_public_path__ + "static/media/loadingTitle.a45e80f8.svg";